import React, { createContext, useState, useLayoutEffect, useContext, SetStateAction, Dispatch } from 'react'
import { useLocation } from 'react-router-dom'

const UseErrorStatusContext = createContext<Dispatch<SetStateAction<number>>>(() => null)
const ErrorStatusContext = createContext<number>(0)
type Props = {
  children: React.ReactNode
}
const ErrorHandler = ({ children }: Props) => {
  const { pathname } = useLocation()
  const [errorStatusCode, setErrorStatusCode] = useState<number>(0)

  // 페이지 이동시 이전 상태 제거
  useLayoutEffect(() => {
    setErrorStatusCode(0)
  }, [pathname])

  const contextPayload = React.useMemo<Dispatch<SetStateAction<number>>>(() => setErrorStatusCode, [setErrorStatusCode])

  return (
    <UseErrorStatusContext.Provider value={contextPayload}>
      <ErrorStatusContext.Provider value={errorStatusCode}>{children}</ErrorStatusContext.Provider>
    </UseErrorStatusContext.Provider>
  )
}

const useSetErrorStatus = () => useContext(UseErrorStatusContext)
const useGetErrorStatus = () => useContext(ErrorStatusContext)
export { ErrorHandler, useSetErrorStatus, useGetErrorStatus }
